<template>
  <c-app>
    <c-content>
      <section class="sign u-m-auto">
        <div class="sign__body">
          <h1 class="sign__title u-fs-24">Reestablecer Contraseña</h1>
          <p class="sign__text">Ingrese su nueva Contraseña</p>
          <c-form action="/login" method="GET">
            <input type="hidden" v-model="rcu" />
            <input type="hidden" v-model="rcd" />
            <c-flash type="danger" :closeable="false" v-show="errorMessage != ''">{{ errorMessage }}</c-flash>
            <c-form-field>
              <c-form-input icon-start="icon-lock" v-model="Password" type="password" placeholder="Nueva Contraseña"></c-form-input>
            </c-form-field>
            <c-form-field label="Repeat Password">
              <c-form-input icon-start="icon-lock" v-model="PasswordConfirm" type="password"></c-form-input>
            </c-form-field>
            <c-button type="danger" @click.prevent="reset" block>Reestablecer Contraseña</c-button>
          </c-form>
          <div style="text-align:center;">
          <img src="../assets/rmgridlogoBlue.png" alt="rmgrid" style="width:50%;margin-top:20px;">
          </div>
        </div>
        <footer class="sign__footer u-text-center">
          <p class="u-text-muted u-fs-12">RMGRID by Riverminds Cia. Ltda.<br>© 2017-2018. Todos los Derechos Reservados.</p>
        </footer>
      </section>
    </c-content>
  </c-app>
</template>

<script>
  export default {
    name: 'ForgotView',
    mounted: function () {
      this.rcu = this.$route.query.rcu;
      this.rcd = this.$route.query.rcd;
    },
    data() {
      return {
        baseServiceUrl: window.baseServiceUrl,
        rcu: '',
        rcd: '',
        Password: "",
        PasswordConfirm: "",
        errorMessage: ""
      }
    },
    methods: {
      reset() {

        if (this.Password != this.PasswordConfirm)
          {

              this.$notify({
                type: 'danger',
                title: 'Actualización de Datos',
                content: 'La nueva contraseña no coincide con la verficación de la nueva contraseña!',
                closeable: true,
                duration: 10000
              });
              return;
          }
          if (this.Password == false || this.Password == "")
          {

              this.$notify({
                type: 'danger',
                title: 'Actualización de Datos',
                content: 'La contraseña esta en blanco!',
                closeable: true,
                duration: 10000
              });
              return;
          }

        const vm = this.$toast.loading("Actualizando Contraseña...");
        this.$http.post(baseServiceUrl + 'api/accountapi/resetpassword', {
          rcd: this.rcd,
          rcu: this.rcu,
          Password: this.Password
        }).then(function(response){
          vm.hide();
            this.$notify({
                type: 'success',
                title: 'Recuperación de contraseña',
                content: 'La contraseña se ha reestablecido correctamente!',
                closeable: true,
                duration: 10000
              });
            this.$router.replace('/login')
          
          }, function(e){

            vm.hide();
            if (e != null && e.body != null && e.body.Message != null)
            {
              this.errorMessage = e.body.Message;
            }

        });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/reset.vue